import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Document} from '../model/Entities/Document';
import {DocumentType} from '../model/Entities/DocumentType';

@Injectable()
export class DocumentTypeService extends ApiService<DocumentType> {

    protected apiUrl = 'api/document-type';  // URL to web api

    protected getObjectType(): any {
        return DocumentType;
    }
}



// WEBPACK FOOTER //
// /app/src/services/document-type.service.ts